import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventsService } from '../services/events.service';
import { Subject } from 'rxjs';
import { LoggingService } from '../services/logging.service';

@Component({
  selector: 'app-auto-suspend',
  templateUrl: './auto-suspend.component.html',
  styleUrl: './auto-suspend.component.scss'
})
export class AutoSuspendComponent implements OnInit, OnDestroy {
  @Input() quoteStateId: number;
  minutesBeforeAutoSuspend: number;
  time: string;
  timeLeft: number;
  startTime: number;
  timer: ReturnType<typeof setInterval>;
  intervalMs = 1000;
  suspended: boolean = false;
  destroy$ = new Subject();
  showTime: boolean = false;

  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private eventService: EventsService,
    private loggingService: LoggingService
  ) {
  }

  ngOnInit() {
    this.updateTime();
    this.startCountdown(this.minutesBeforeAutoSuspend);
  }

  startCountdown(minutesBeforeAutoSuspend: number) {
    const durationInSeconds = minutesBeforeAutoSuspend * 60;
    this.startTime = Date.now();
    this.timeLeft = durationInSeconds;

    this.timer = setInterval(() => {
      const elapsedSeconds = Math.floor((Date.now() - this.startTime) / this.intervalMs);
      const remaining = durationInSeconds - elapsedSeconds;

      if (remaining > 0) {
        this.timeLeft = remaining;
        this.updateTime();
      } else {
        this.suspended = true;
        this.suspendPurchase();
        clearInterval(this.timer);
      }
    }, this.intervalMs)
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  updateTime(): void {
    const minutes = Math.floor(this.timeLeft / 60);
    const seconds = this.timeLeft % 60;
    if(!this.showTime){
      this.showTime = !isNaN(seconds) && !isNaN(minutes);
    }
    this.time = `${minutes} Minute${minutes !== 1 ? 's' : ''} ${seconds} Second${seconds !== 1 ? 's' : ''}`;
  }

  suspendPurchase() {
    const message = `AutoSuspend-${this.quoteStateId} Purchase was auto-suspended`;
    this.loggingService.logInfo(message);
    this.eventService.suspendPurchase.emit();    
  }

  close(): void {
    if (this.suspended) {
      this.modalService.dismissAll();
    } else {
      this.activeModal.close();
    }
  }
}
